<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("wishlist") }}</div>
      </h2>
    </div>
    <div class="courses-all-list" v-if="wishlist">
      <CoursesCard
        v-for="item in wishlist"
        @close="cardRemove"
        :close="true"
        :key="item.id"
        :data="item"
      />
    </div>
    <div v-else>
      <p>{{ $t("no_wishlist") }}</p>
    </div>
    <DeleteCoursePopup
      @close="deletePopupFunc"
      :delete-event="true"
      @delete="deleteCourses"
      v-if="deletePopup"
    />
  </div>
</template>

<script>
import CoursesCard from "@/components/CoursesCard";
import DeleteCoursePopup from "@/components/DeleteCoursePopup";

export default {
  title: "Meni qiziqtirgan kurslar",

  data() {
    return {
      deletePopup: false,
      id: null,
    };
  },
  methods: {
    cardRemove(e) {
      this.deletePopup = e.event;
      this.id = e.id;
      console.log(e);
    },
    deletePopupFunc(e) {
      this.deletePopup = e;
      this.id = null;
    },
    async deleteCourses(e) {
      if (e) {
        try {
          await this.$store.dispatch("removeWishlist", { id: this.id });
          this.deletePopup = false;
          if (localStorage.getItem("access")) {
            await this.$store.dispatch("getWishlist");
          }
        } catch (e) {
          console.log(e);
        }
      }
      this.id = null;
    },
  },

  computed: {
    wishlist() {
      return this.$store.getters.getWishlist;
    },
  },
  components: {
    CoursesCard,
    DeleteCoursePopup,
  },
};
</script>
